import pl from './pl';
import ro from './ro';

export const LANGUAGES = ['en', 'pl', 'ro'];

export type TLanguages = 'en' | 'pl' | 'ro' | string;

type TTranslation = {
  [key: string]: string;
}

type TTranslations = {
  [key: string]: TTranslation;
}

const translations: TTranslations = {
  pl, ro,
};

function replaceHTMLSymbols(key: string) {
  return key.replace(/&nbsp;/g, '\u00A0')
    .replace(/&bull;/g, '\u2022')
    .replace(/&rsquo;/g, '\u2019')
    .replace(/&mdash;/g, '\u2014')
    .replace(/&euro;/g, '\u20AC')
    .replace(/&oacute;/g, '\u00F3');
}

class Translation {
  private translations: TTranslation;

  private language: TLanguages;

  constructor(language: TLanguages) {
    this.translations = translations[language];
    this.language = language || 'en';

    this.get = this.get.bind(this);
  }

  get(key: string) {
    if (!this.translations) {
      return replaceHTMLSymbols(key);
    }

    if (!this.translations[key]) {
      console.group('%c[QA TRANSLATION LOG]: NO_TRANSLATION', 'background: #EC0B43; color: white');
      console.log('%cNo translation for:', 'color: Red');
      console.log(`%c${key}`, 'color: DodgerBlue');
      console.log('%cin language:', 'color: Red');
      console.log(`%c${this.language}`, 'color: DodgerBlue');
      console.groupEnd();
      return replaceHTMLSymbols(key);
    }

    return replaceHTMLSymbols(this.translations[key]);
  }

  getLang() {
    return this.language;
  }
}
export default Translation;
